import { memo } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { ScreeningStatus } from '@/lib/validations/bits-api/entities/list-entities-response';

export const ScreeningStatusIndicator = memo(
  ({
    status,
    showText = true,
  }: {
    status: ScreeningStatus;
    showText?: boolean;
  }) => {
    const { t } = useTranslation('enums');

    return (
      <div className="flex items-center gap-2">
        <div
          className={clsx('size-2 shrink-0 rounded-full', {
            'bg-grapefruit': status === 'CONFIRMED_MATCH',
            'bg-grapefruit-light': status === 'POSSIBLE_MATCH',
            'bg-kiwi': status === 'NO_MATCH',
            'bg-smoke': status === 'NOT_SCREENED',
          })}
        />
        {showText && <div className="leading-tight">{t(status)}</div>}
      </div>
    );
  }
);
ScreeningStatusIndicator.displayName = 'ScreeningStatusIndicator';
